import * as React from 'react';
import styled from '@emotion/styled';
import { Magnetic } from '../../styles';
const HeaderLayout = styled('header')((props) => `
        background-color: ${props.headerBackgroundColor};
        color: ${props.headerColor};
        justify-content: space-between;
        align-items: center; /* Added to vertically center content */
        display: flex; /* Added to make flexbox work */
        line-height: 2.5rem;
        padding: 0 ${Magnetic.spacer20};
        text-align: center;
    `);
const HeaderContent = styled('div')(`
    flex: 1; /* Added to take remaining space */
    text-align: center;
    line-height: center;
    padding-top: ${Magnetic.spacer04};
`);
const StyledBackNavigationIcon = styled('div')(`
	cursor:${Magnetic.actionableCursor};
	padding:  ${Magnetic.spacer12};
	margin: 0 -${Magnetic.spacer12};
`);
const StyledSkipText = styled('span')(`
	cursor: ${Magnetic.actionableCursor};	
	line-height: center;
    padding-top: ${Magnetic.spacer04};
`);
export const WhiteLabelMobileHeader = (props) => {
    const { headerText, headerBackgroundColor, headerColor, skipOptionText, onNavigationClick, onSkipOptionClick } = props;
    const onBackNavigationClick = () => {
        onNavigationClick && onNavigationClick();
    };
    const onSkipOptionTextClick = () => {
        onSkipOptionClick && onSkipOptionClick();
    };
    return (React.createElement(HeaderLayout, { headerBackgroundColor: headerBackgroundColor, headerColor: headerColor, id: "whiteLabelMobileHeader_text" },
        props.shouldDisplayNavigationIcon && (React.createElement(StyledBackNavigationIcon, { onClick: onBackNavigationClick, className: "mi-icon-pagination-left-bold" })),
        React.createElement(HeaderContent, { id: "whiteLabelMobileHeader_textContent" },
            React.createElement("span", { id: "whiteLabelMobileHeader_textSpan" }, headerText)),
        props.skipOptionText && (React.createElement(StyledSkipText, { id: "whiteLabelMobileHeader_skipDivTextSpan", onClick: onSkipOptionTextClick },
            React.createElement("span", { id: "whiteLabelMobileHeader_skipTextSpan" }, skipOptionText)))));
};
//# sourceMappingURL=WhiteLabelMobileHeader.js.map